// Insight utils
// --------------------------------------------------------
let utils = {}
// Add extra properties to original Insights
utils.parseInsights = insights => insights.forEach(parseInsight)
const parseInsight = insight => {
  if (!insight.lastComment) {
    insight.lastComment = '1981-11-26T00:00:00.000Z' // very old
  }
  insight.lastActivityAt = insight.updatedAt
  if (insight.lastComment > insight.updatedAt) {
    insight.lastActivityAt = insight.lastComment
  }
}

export default utils
